import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function MyCV(){
    return(
        <>
        <div className="MyCV-maincontent">
            <Typography variant="h1">My CV</Typography>
            <Typography variant="h2">Check out my experience.</Typography>

            <br/>

            <div className="CV-container">
                <div className="CV-header">
                    <Typography variant="body1">linhnguyen.tibiaart@gmail.com </Typography> |
                    <Link href="https://github.com/ViLinh27">
                        <Typography variant="body1">My github</Typography>
                    </Link> | 
                    <Link href="https://www.linkedin.com/in/vilinhnguyen27/">
                        <Typography variant="body1">My linkedin</Typography>
                    </Link>
                </div>{/*cv header */}

                <div className="CV-education">
                    <Typography variant="h3">Education</Typography>

                    <div className="cv-e_item">
                        <div className="cv-e_school">
                            <Typography variant="h4">DePaul University</Typography>
                            <Typography variant="body1">M.S. - Computer Science, Human Computer Interaction Concentration</Typography>
                        </div>
                        <div className="cv_Info">
                            <Typography variant="body1">Chicago, IL</Typography>
                            <Typography variant="body1">Graduation Date: Dec 2023</Typography>
                        </div>
                    </div>

                    <div className="cv-e_item">
                        <div className="cv-e_school">
                            <Typography variant="h4">Columbia College Chicago</Typography>
                            <Typography variant="body1">B.A. - Cinema Arts and Sciences, Animation Concentration</Typography>
                        </div>
                        <div className="cv_Info">
                            <Typography variant="body1">Chicago, IL</Typography>
                        </div>
                    </div>
                </div>

                <div className="CV-work">
                    <Typography variant="h3">Work Experience</Typography>

                    <div className="cv-w_item">
                        <div className="cv-w_job">
                        <Typography variant="h4">Happy Mercs</Typography>
                        <Typography variant="h5">Animator</Typography>
                        <ul>
                            <li>
                            <Typography variant="body2">
                                Presented constructive feedback on colleagues' assigned animation clips, actively participated in brainstorming
                            sessions to refine pilot project concepts.
                            </Typography>
                                
                            </li>
                            <li>
                            <Typography variant="body2">
                                Collaborated with on remote team of 8 people to develop cohesive animation sequences that seamlessly integrate
                            with pilot trailer.
                            </Typography>
                                
                            </li>
                            <li>
                            <Typography variant="body2">
                                Delivered high-quality 2D character animations with a frame rate of 24 fps, ensuring fluid movement by industry
                            standard.
                            </Typography>
                                
                            </li>
                        </ul>
                        </div>
                        <div className="cv_Info">
                            <Typography variant="body1">New York City</Typography>
                            <Typography variant="body1">Sep 2024 - Oct 2024</Typography>
                        </div>

                        <div className="cv_Info">
                            <Typography variant="body1">New York City</Typography>
                            <Typography variant="body1">Oct 2018 - Jan 2019</Typography>
                        </div>
                    </div>

                    <div className="cv-w_item">
                        <div className="cv-w_job">
                        <Typography variant="h4">CIP Chicago</Typography>
                        <Typography variant="h5">Web Developer | Web Designer</Typography>
                        <ul>
                            <li>
                                <Typography variant="body2">
                                    Conducted competitive analysis of 6 industry leading websites, indentifying 3 key design trends and best practices
                                    directly applicable to organization goals.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Executed a complete overhaul of the organization's website, following new branding guidelines from the supervisor,
                            resulting in a 20% increase in organic website traffic and a 15% boost in conversion rates.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Analyzed and evaluated potential international talent based on supervisor criteria, resulting in a 30% increase in the
                                    number of qualified candidates for consideration.
                                </Typography>
                            </li>
                        </ul>
                        </div>
                        <div className="cv_Info">
                        <Typography variant="body1">Chicago</Typography>
                        <Typography variant="body1">Mar 2023 - Jun 2023</Typography>
                        </div>
                    </div>
                
                    <div className="cv-w_item">
                        <div className="cv-w_job">
                        <Typography variant="h4">HUGS International</Typography>
                        <Typography variant="h5">Frontend Web Developer</Typography>
                        <ul>
                            <li>
                                <Typography variant="body2">
                                    Developed responsive website pages adhering to W3C standards and cross-browser compatibility best practices.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Successfully fixed high severity bugs as needed by the product manager, ensuring more efficient code review.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Integrated frontend with backend ensuring smooth data flow between user interface and server-side logic with
                            guidance from backend team.
                                </Typography>
                            </li>
                        </ul>
                        </div>
                        <div className="cv_Info">
                        <Typography variant="body1">San Diego</Typography>
                        <Typography variant="body1">Feb 2022 - May 2022</Typography>
                        </div>
                    </div>
                
                    <div className="cv-w_item">
                        <div className="cv-w_job">
                        <h4>SuperWorld</h4>
                        <h5>Frontend Web Developer</h5>
                        <ul>
                            <li>
                                <Typography variant="body2">
                                    Troubleshooted React and Javascript errors in organization's website application, leading to a smoother user
                            experience.
                                </Typography>
                                
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Navigated series of iterative design tests on application page sections to meet evolving supervisor requirements,
                            guided closely UX team, resulting in 20% increase in user engagement metrics.
                                </Typography>
                                
                            </li>
                            <li>
                                <Typography variant="body2">
                                    Collaborated with design team to seamlessly integrate new branding elements into web application sections, resulting
                            in a 10% improvement in overall user experience.
                                </Typography>
                                
                            </li>
                        </ul>
                        </div>
                        <div className="cv_Info">
                        <Typography variant="body1">San Francisco</Typography>
                        <Typography variant="body1">Jan 2021 - Jun 2021</Typography>
                        </div>
                    </div>

                </div>{/*cv work */}

                <div className="CV-skills">
                    <Typography variant="h3">Skills</Typography>
                    <hr />
                    <div className="cv-s_table">
                        <table>
                            <tr>
                                <th>
                                    <Typography variant="body1">
                                        Frontend Development:
                                    </Typography>
                                    
                                </th>
                                <td>
                                <div className="cv-s_tableInfo">
                                    <div>
                                        <Typography variant="body2">
                                            React JS
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            HTML
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            CSS3
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Javascript
                                        </Typography>
                                        
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <Typography variant="body1">
                                        Backend Development:
                                    </Typography>
                                
                                </th>
                                <td>
                                <div className="cv-s_tableInfo">
                                    <div>
                                        <Typography variant="body2">
                                            Node.js
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Swift
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Java
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            SQL
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            C#
                                        </Typography>
                                        
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Python
                                        </Typography>
                                    
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <Typography variant="body1">
                                        Design:
                                    </Typography>
                                    
                                </th>
                                <td>
                                <div className="cv-s_tableInfo">
                                    <div>
                                        <Typography variant="body2">
                                            Adobe Illustrator
                                        </Typography>
                                    
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Adobe Photoshop
                                        </Typography>
                                    
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Adobe Flash
                                        </Typography>
                                    
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Figma
                                        </Typography>
                                    
                                    </div>
                                    <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                    <div>
                                        <Typography variant="body2">
                                            Axure
                                        </Typography>
                                    
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                            <th>
                                <Typography variant="body1">
                                   Miscellaneous: 
                                </Typography>
                            </th>
                            <td>
                            <div className="cv-s_tableInfo">
                                <div>
                                    <Typography variant="body2">
                                       Git 
                                    </Typography>
                                </div>
                                <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                <div>
                                    <Typography variant="body2">
                                        French Fluency
                                    </Typography>
                                    
                                </div>
                                <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                <div>
                                    <Typography variant="body2">
                                        Vietnamese Fluency
                                    </Typography>
                                    
                                </div>
                                <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                <div>
                                    <Typography variant="body2">
                                        Microsoft Word
                                    </Typography>
                                    
                                </div>
                                <div>
                                        <Typography variant="body2">
                                            |  
                                        </Typography>
                                     
                                     </div>
                                <div>
                                    <Typography variant="body2">
                                        Microsoft Powerpoint
                                    </Typography>
                                    
                                </div>
                            </div>
                            </td>
                        </tr>
                        </table>
                    </div>
                </div>{/*cv skills */}

                <div className="CV-courses">
                    <Typography variant="h3">Coursework</Typography>
                    <hr />
                    <div className="cv-c_container">
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Data Structures I & II
                            </Typography>
                            
                        </div> 
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Applied Algorithms
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Discrete Math
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Systems I & II
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Android Development I 
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                IOS Development I 
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                User Centered Design
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Prototyping and Implementation
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Information Architecture
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-c_course">
                            <Typography variant="body2">
                                Automata Theory
                            </Typography>
                            
                        </div>
                    </div>
                </div>{/* cv courses */}
            
                <div className="CV-interests">
                    <Typography variant="h3">Interests</Typography>
                    <hr />
                    <div className="cv-i_container">
                        <div className="cv-i_interest">
                            <Typography variant="body2">
                                Web Development
                            </Typography>
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-i_interest">
                            <Typography variant="body2">
                                Mobile Application Development
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-i_interest">
                            <Typography variant="body2">
                               UX 
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-i_interest">
                            <Typography variant="body2">
                                Illustration
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                        <div className="cv-i_interest">
                            <Typography variant="body2">
                                Design
                            </Typography>
                            
                        </div>
                        <Typography variant="body2">
                            |
                        </Typography>
                    </div>
                </div>{/*cv inerests */}

            </div>{/*cv container */}

        </div>{/* mycv -maincontent */}
        </>
    );
}

export default MyCV;